import {
  CreateButton,
  Datagrid,
  FunctionField,
  ExportButton,
  List,
  TextField,
  TopToolbar,
  FilterLiveSearch,
  RaRecord,
    FilterList, FilterListItem,
  Button as AdminButton,
  useListContext,
  useListController,
} from "react-admin";
// import CustomReferenceField from "../Common/CustomReferenceField";
import { TimeEnum } from "../../enums/TimeEnum";
import { PaymentStatusEnum } from "../../enums/PaymentStatusEnum";
import { OneMealServiceStatus } from "../../enums/OneMealServiceStatus";
import { UserType } from "../../enums/common";
import CallButton from "../Common/CallButton/CallButton";
import { Box, Button, Card, CardContent, Chip, IconButton, InputLabel, Link, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { FilterAlt, FilterAltOff } from "@mui/icons-material";
import { setOmsSideFilter } from "../../store/reducers/customSelect";
import MetabaseTransactionButton from "../Common/MetabaseDashboardButton";
import { MetabaseDasboardId } from "../../enums/MetabsaeDashboardId";
import EventNoteIcon from '@mui/icons-material/EventNote';
import { formatDate, formatDateTimeWithSeconds } from '../../utils/DateTimeUtils';
import CityService from "../../services/CityService";
import {useEffect, useState} from "react";
import CityResponse from "../../interfaces/City/CityResponse";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import TrialsCancelDialog from "../Common/TrialsCancelDialog";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import ChangeOmsTimeDialog from "../Common/ChangeOmsTimeDialog";
import CustomReferenceField from "../Common/CustomReferenceField";
import RemoveCookFromOmsDialog from "../Common/RemoveCookFromOmsDialog";
import { useNavigate } from "react-router-dom";
import BoltIcon from '@mui/icons-material/Bolt';
import { getChipColors, TrackingStatusEnum } from "../VisitTracker/VisitTrackerList";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const FilterSidebar = () => {
  return (
      <Box
          sx={{
              marginTop: "15px",
              display: {
                  xs: 'none',
                  sm: 'block'
              },
              order: -1,
              width: '17em',
              marginRight: '1em',
          }}
      >
          <Card
          style={{
          maxHeight: '60%',
          overflow: 'auto'
          }}>
            <CardContent>
              <InputLabel >Customer Name</InputLabel>
              <FilterLiveSearch source="customerName" />
              <InputLabel >Cook Name</InputLabel>
              <FilterLiveSearch source="cookName" />
              <InputLabel >Cook Phone</InputLabel>
              <FilterLiveSearch source="cookPhoneNumber" />
              <InputLabel >Trial Owner Name</InputLabel>
              <FilterLiveSearch source="trialOwnerName" />
              <InputLabel >Sector</InputLabel>
              <FilterLiveSearch source="sector" />
              <InputLabel >Cancelled By(Customer/admin)</InputLabel>
              <FilterLiveSearch source="cancelledBy"/>
              <FilterList
                label="Cook Acknowledge"
                icon={''}
                sx={{mb: 2}}
              >
                <FilterListItem
                    label="Yes"
                    value={{ cookAcknowledged: true }}
                />
                <FilterListItem
                    label="No"
                    value={{ cookAcknowledged: false }}
                />
            </FilterList>
              <FilterList
                label="Customer Acknowledge"
                icon={''}
                sx={{mb: 2}}
              >
                <FilterListItem
                    label="Yes"
                    value={{ isCheckinValid: true }}
                />
                <FilterListItem
                    label="No"
                    value={{ isCheckinValid: false }}
                />
            </FilterList>
              <InputLabel >Cook Accepted</InputLabel>
              <FilterLiveSearch source="numberOfCookAccepted" />
              <InputLabel >Shortlisted Cook</InputLabel>
              <FilterLiveSearch source="numberOfCookAllocated" />
              <InputLabel >Non-Allocated Trial(true/false)</InputLabel>
              <FilterLiveSearch source="localityId" />
            </CardContent>
          </Card>
      </Box>
  )
};
const ListActions = (props: any) => {
  const dispatch = useAppDispatch();
  const { setFilters } = useListContext();
    const resetFilter = () => {
      setFilters({}, [], false);
    };
  return(
  <TopToolbar>
      <AdminButton
        variant="text"
        size={"small"}
        onClick={resetFilter}
        startIcon={<FilterListOffIcon />}
        label="Clear filters"
      />
      <Link href={"#/CooksServeCalendar"} target={'_self'} underline="none">
          <Button size="small" variant={"text"} startIcon={<EventNoteIcon/>}>
              Open TimeTable
          </Button>
      </Link>
      <MetabaseTransactionButton dashboardId={MetabaseDasboardId.OMS} />
      <Button variant="text"
        size={"small"}
        onClick={() => {
          dispatch(setOmsSideFilter({
            omsSideFilter: !props.openSideFilter
          }))
        }}
        startIcon={props.openSideFilter ? <FilterAlt /> : <FilterAltOff />} color="primary"
      >
        Filter
      </Button>
      <CreateButton />
      <ExportButton />
  </TopToolbar>
)};

const cityService = new CityService();

let RenderCTAButtons = (props: any) => {
  let [cancelTrialModel, setCancelTrialModel] = useState<boolean>(false);
  let [hasPreAllocationVisits, setHasPreAllocationVisits] = useState<boolean>(false);
  let [changeTime, setChangeTime] = useState<boolean>(false);
  let [removeCook, setRemoveCook] = useState<boolean>(false);
  const navigate = useNavigate()

  let verifyByVisitStatus = () =>{
    let hasPostAllocationVisits = false;
    let hasPreAllocationVisits = false;

    if (props.visits) {
      for (let i = 0; i < props.visits.length; i++) {
        const visit = props.visits[i];
    
        if ([OneMealServiceStatus.COOK_ALLOCATED, OneMealServiceStatus.COOK_CONFIRMED, OneMealServiceStatus.ONGOING].includes(visit?.status)) {
          hasPostAllocationVisits = true;
          setHasPreAllocationVisits(false);
        }
    
        if ([OneMealServiceStatus.PENDING].includes(visit?.status)) {
          hasPreAllocationVisits = true;
          setHasPreAllocationVisits(true);
        }
    
        if (hasPreAllocationVisits && hasPostAllocationVisits) {
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Cannot cancel both pre and post allocation Visits",
            type: CustomSnackbarTypes.ERROR,
          });
          setCancelTrialModel(false)
          return;
        }
        setCancelTrialModel(true);
      }
      return;
    }
  }
  return (
    <Box ml={4} display={'flex'} gap={4}>
    {
          cancelTrialModel && <TrialsCancelDialog
                intiatedBy={2}
                data={''}
                open={cancelTrialModel}
                callback={() => {
                  setCancelTrialModel(false);
                }}
                chefitIds = {props?.selectedIds}
                hasPreAllocationVisits = {hasPreAllocationVisits}
              />
    }
    {
      changeTime && <ChangeOmsTimeDialog open={changeTime} setOpen={setChangeTime} data={props?.selectedIds} isBulkOperation = {true} />
    }
    {
      removeCook && <RemoveCookFromOmsDialog open={removeCook} setOpen={setRemoveCook} data={props?.selectedIds} />
    }
      <Button
        onClick={() =>
          navigate('/assignMultiple', {
            state: { selectedIds: props?.selectedIds }
          })
        }
        variant="outlined"
      >
        Allocate Cook
      </Button>
      <Button onClick={()=> verifyByVisitStatus()} variant="outlined">Cancel Visits</Button>
      <Button onClick={()=> setChangeTime(true)} variant="outlined">Change Time</Button>
      <Button onClick={()=> setRemoveCook(true)} variant="outlined">Remove Cook</Button>
    </Box>
  )
}

const OneMealServiceList = (props: any) => {
  const showSideFilter = useAppSelector((s) => s.customSelect.value.omsSideFilter)
  const userDetails = useAppSelector((state) => state.userDetails.value);
  const userGroups: string[] = userDetails.adminUser.accessGroups;
    const [cities, setCities] = useState<CityResponse[]>([]);
    const { selectedIds, data } = useListController();
    const navigate = useNavigate()

    
    
    function filterDataRows(){
      let serviceWithNonTerminalStatus = data && data.filter((row) => (selectedIds.includes(row?.id) && ![OneMealServiceStatus.CANCELLED, OneMealServiceStatus.FULFILLED, OneMealServiceStatus.RESCHEDULED].includes(row?.status)));
      return(serviceWithNonTerminalStatus && serviceWithNonTerminalStatus.length ? <RenderCTAButtons selectedIds={selectedIds} visits={serviceWithNonTerminalStatus} userGroups={userGroups}/> : <></>)
    }
    const filterFields: CommonFilterField[] = [
        { type: "text", label: "ID", source: "id", numeric: true },
        {
            type: "select",
            label: "Status",
            source: "status",
            options: Object.values(OneMealServiceStatus).map((key) => ({
                value: key,
                label: key,
            })),
        },
        {
            type: "select",
            label: "Payment Status",
            source: "paymentStatus",
            options: Object.values(PaymentStatusEnum).map((key) => ({
                value: key,
                label: key,
            })),
        },
        {
            type: "select",
            label: "Pre Checked In",
            source: "preCheckedInAt",
            options: [
                { value: "YES", label: "Yes" },
                { value: "NO", label: "No" },
            ],
        },
        { type: "date", label: "Date", source: "date" },
        {
            type: "multiselect",
            label: "Time",
            source: "time",
            options: Object.values(TimeEnum).map((value) => ({
                value,
                label: value,
            })),
        },
        {
            type: "select",
            label: "City",
            source: "cityId",
            options: cities.map((eachCity: any) => ({
                value: eachCity?.id,
                label: eachCity?.name,
            })),
        },
        {
            type: "select",
            label: "OMS Type",
            source: "omsType",
            options: [
                { value: "Normal OMS", label: "Normal OMS" },
                { value: "TR OMS", label: "TR OMS" },
            ],
        },
        {
            type: "select",
            label: "Cx Acknowledge",
            source: "isCheckinValid",
            options: [
                { value: "true", label: "Yes" },
                { value: "false", label: "No" },
            ],
            toFilter: (value) => value === "true",
            fromFilter: (value) => String(value),
        },
        {
            type: "select",
            label: "Is MultiChefit",
            source: "isMultiDayChefit",
            options: [
                { value: "YES", label: "YES" },
                { value: "NO", label: "NO" },
            ],
        },
        {
            type: "text",
            label: "Multi Day Chefit Id",
            source: "multiDayChefitId",
            numeric: true,
        },
        {
            type: "select",
            label: "Is Instantchefit",
            source: "isInstantChefit",
            options: [{ value: "true", label: "YES" }],
        },
        {
            type: "multiselect",
            label: "Tracking Status",
            source: "trackingStatus",
            options: Object.values(TrackingStatusEnum).map((value) => ({
                value,
                label: value,
            })),
        },
        { type: "text", label: "Customer Phone", source: "customerPhoneNumber" },
    ];
    useEffect(() => {
        cityService.fetchAllCities(100, 0, {isCurrentlyServing:"YES"}, {}).then((res) => {
            setCities(res?.data);
        })
    }, []);
  return (
    <List
      {...props}
      className="toolbar-custom-css"
      actions={<ListActions openSideFilter={showSideFilter} />}
      aside={showSideFilter ? <FilterSidebar /> : null}
      sort={{ field: 'id', order: 'DESC' }}
      sx={{
        "& .RaList-content": {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
        ...(selectedIds?.length === 0
          ? { '& .RaBulkActionsToolbar-toolbar': { display: 'none' } }
          : {}),
      }}
    >
      <CommonFilterCard fields={filterFields} />

      <br />

      <StyledDatagridWrapper title="Chefit">
      <Datagrid
        rowClick="show"
        bulkActionButtons={filterDataRows()}
        sx={{
          ...commonDatagridSx,
          ...(selectedIds?.length !== 0 ? { mt: "3rem", mb: "3rem" } : {}),
        }}
      >
        <FunctionField
          label="ID (Copy URL →)"
          sortBy="id"
          render={(record?: RaRecord) => (
            <Box display="flex" alignItems="center" gap={0.5} onClick={(e) => e.stopPropagation()}>
              <span>{record?.id}</span>
              {record?.isInstantChefit && <BoltIcon sx={{ color: "#FF9800", fontSize: 20 }} />}
              <Tooltip title="Copy URL to this chefit's detail page">
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(
                      `${window.location.origin}/#/OneMealService/${record?.id}/show`
                    );
                  }}
                  sx={{ p: 0.25 }}
                >
                  <ContentCopyIcon sx={{ fontSize: 14 }} />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        />
        <TextField source="customerName" sortable={false} />
        <TextField source="paymentStatus" sortable={false} />
        <FunctionField
          label="Customer Phone Number"
          render={(record: any) => (
            <Box onClick={(e) => e.stopPropagation()}>
              <CallButton
                toPhoneNumber={record?.customerPhoneNumber}
                userType={UserType.CUSTOMER}
                referenceId={Number(record?.id)}
                referenceModelName={"ONE_MEAL_SERVICE"}
              />
            </Box>
          )}
        />
        {/*<CustomReferenceField*/}
        {/*  label="House"*/}
        {/*  listName={"Houses"}*/}
        {/*  source={"houseId"}*/}
        {/*/>*/}
        {/* <WrapperField label="Address">
          <TextField width="30%" source="house.address" />
          <TextField width="30%" source="house.locality" />
          <TextField width="30%" source="house.city" />
        </WrapperField> */}
        <TextField label={'Sector'} source="areaName" sortable={true} />
        <TextField label={'Locality'} source="localityName" sortable={true} />
        <FunctionField
          label="Date"
          sortBy="date"
          render={(record?: RaRecord) => (
            <span style={{ whiteSpace: 'nowrap' }}>
              {record?.date ? formatDate(record.date) : '-'}
            </span>
          )}
        />
        <TextField 
          source="time" 
          sortable={true}
          sx={{
            whiteSpace: 'nowrap'
          }}
        />
        <FunctionField
          emptyText="Not Available"
          label="Status"
          render={(record:any) =>
              <>
              <div>{record?.status}</div>
              {record?.preCheckedInAt&&record?.status===OneMealServiceStatus.COOK_CONFIRMED?<div>PRE CHECKED IN</div>:<></>}
              </>
          }
        /> 
        <FunctionField
          label="MultiDay Id"
          render={() => (
            <Box onClick={(e) => e.stopPropagation()}>
              <CustomReferenceField
                label="MultiDay Id"
                listName={"MultiDayChefit"}
                source={"multiDayChefitId"}
              />
            </Box>
          )}
        />
        <FunctionField sx={{
          display: 'inline-block',
          width: '65px',
        }} label="Pay After Service" render={(record?: RaRecord) => {
          if (record?.hasOptedPayAfterService) {
            return (
              <Typography fontSize={'0.875rem'} fontWeight={600} color={'#047a04'}>Opted</Typography>
            )
          }
          else {
            return (
              <Typography fontSize={'0.875rem'} fontWeight={600} color={'#c80101'}>Not Opted</Typography>
            )
          }
        }} />
        <TextField source="adminNotes" sortable={false} />
        <FunctionField
          label="Cook Name"
          render={(record: any) => {
            if (!record?.cookName) {
              return `Not Available`
            }
            return `${record?.cookName}`
          }
          }
        />
        <FunctionField
          label="Tracker"
          render={(record: any) => (
            [OneMealServiceStatus.COOK_ALLOCATED, OneMealServiceStatus.COOK_CONFIRMED, OneMealServiceStatus.ONGOING].includes(record?.status) &&
            <Button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/VisitTracker/ONE_MEAL_SERVICE/${record?.id}/${record?.cookId}`, {
                state: { visitData: record },
              });
            }}
            variant="contained"
            color="success"
            sx={{fontSize: '12px', padding: '6px'}}
          >
            Tracker
          </Button>
          )}
        />
        <FunctionField
          label="Cook Phone Number"
          render={(record: any) => (
            <Box onClick={(e) => e.stopPropagation()}>
              <CallButton
                toPhoneNumber={record?.cookPhoneNumber}
                userType={UserType.COOK}
                referenceId={Number(record?.id)}
                referenceModelName={"ONE_MEAL_SERVICE"}
              />
            </Box>
          )}
        />
        <FunctionField
          label="Tracking Status"
          render={(record: any) => (
            <Chip
              label={record?.trackingStatus}
              style={{
                backgroundColor:getChipColors(record?.trackingStatus).backgroundColor,
                color: getChipColors(record?.trackingStatus).color,
                fontWeight: 500,
                fontSize: "12px",
              }}
            />
          )}
        />
        <TextField source="trackingNotes" sortable={false} />
        <TextField source="cancellationReason" sortable={false} />
        <FunctionField label="Created At" render={(record?: RaRecord) => `${record?.createdAt ? formatDateTimeWithSeconds(record?.createdAt) : "Not Available"}`}/>
      </Datagrid>
      </StyledDatagridWrapper>
    </List>
  );
};

export default OneMealServiceList;
